import * as yup from "yup";
import { VALIDATION_MESSAGES } from "./validationMessage";
import { VALIDATION_REGEX } from "./validationRegex";
export const validateSchemas = yup.object({
    buyer: yup
        .string()
        .matches(VALIDATION_REGEX.buyer, VALIDATION_MESSAGES.buyer.pattern)
        .min(2, VALIDATION_MESSAGES.buyer.min)
        .required(VALIDATION_MESSAGES.buyer.required),
    phoneNumber: yup
        .string()
        .matches(VALIDATION_REGEX.phoneNumber, VALIDATION_MESSAGES.phoneNumber.pattern)
        .required(VALIDATION_MESSAGES.phoneNumber.required),
    memo: yup.string().optional(),
    payMethod: yup
        .string()
        .oneOf(["card", "naverpay", "kakaopay", "account"], "결제수단을 골라주세요.")
        .required("결제수단은 필수입니다"),
    bank: yup.string().optional(),
    account: yup.string().optional(),
});

export const checkValidateSchemas = yup.object({
    orderTel: yup
        .string()
        .matches(VALIDATION_REGEX.orderTel, VALIDATION_MESSAGES.orderTel.pattern)
        .required(VALIDATION_MESSAGES.orderTel.required),
    orderNum: yup
        .string()
        .matches(VALIDATION_REGEX.orderNum, VALIDATION_MESSAGES.orderNum.pattern)
        .required(VALIDATION_MESSAGES.orderNum.required),
});
